module.exports = __webpack_public_path__ + "static/media/Totodile_gaussian2.f028a7db.png";